import React, { Component } from "react";

// LIBS
import API from "../../../api";
import { sumFormat } from "../../../lib/helpers/strings";

// UI
import { P, Header, Row, Col, Card } from "../../../ui";

export default class materialBase extends Component {
  state = {
    materialBase: {
      sum_give: 0,
      sum_items: 0,
      count: 0
    }
  };

  async componentDidMount() {
    const materialBase = await API.widgets.getMaterialBase();

    this.setState({ materialBase });
  }

  render() {
    return (
      <Row>
        <Col lg={12} md={12} sm={12} xs={12} padding="no-top-bottom">
          <Header size={4}>Материальная база</Header>
        </Col>
        <Col lg={12} md={12} sm={12} xs={12} padding="no-top-bottom">
          <Card shadow={1} padding="no-top">
            <Row align="center">
              <Col
                padding="no-right-bottom-left"
                lg={6}
                md={12}
                sm={12}
                xs={12}
              >
                <Header size={1} margin="no">
                  {sumFormat(this.state.materialBase.sum_give || 0)}
                </Header>
                <P slim={true}>Сумма выдач</P>
              </Col>
              {/*
              <Col padding="no-right-bottom-left" lg={3} md={6} sm={12} xs={12}>
                <Header size={3} margin="no">
                  {sumFormat(this.state.materialBase.sum_items || 0)}
                </Header>
                <P slim={true}>
                  Сумма оценки вещей
                </P>
              </Col>

              <Col padding="no-right-bottom-left" lg={3} md={6} sm={12} xs={12}>
                <Header size={3} margin="no" className="color-success">
                  {sumFormat(
                    (this.state.materialBase.sum_items || 0) -
                      (this.state.materialBase.sum_give || 0),
                    "",
                    plusSum
                  )}
                </Header>
                <P slim={true}>
                  Разница
                </P>
              </Col>
							*/}
              <Col
                padding="no-right-bottom-left"
                lg={6}
                md={12}
                sm={12}
                xs={12}
              >
                <Header size={4} margin="no">
                  {sumFormat(this.state.materialBase.count || 0)}
                </Header>
                <P slim={true}>Активных билетов</P>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    );
  }
}
